// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator-efficiency-formula {
  margin: 4px 0 0;
  color: #4b6384;
  font-size: 12px;
}

.operator-efficiency-explainer {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 12px;
  padding: 10px 14px;
  border: 1px solid #cfe0f5;
  border-radius: 8px;
  background: #f5f9ff;
  color: #183b66;
  font-size: 12px;
}

.operator-efficiency-explainer > div {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
}

.operator-efficiency-explainer p {
  margin: 0;
  color: #51657f;
  line-height: 1.45;
}

.operator-efficiency-explainer__label,
.operator-muted-text {
  color: #6b7f99;
  font-size: 11px;
}

.operator-coverage,
.operator-efficiency-value,
.operator-cycle-time {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 86px;
  padding: 5px 10px;
  border-radius: 999px;
  background: #e7f6ec;
  color: #137333;
  font-weight: 700;
}

.operator-coverage--warning,
.operator-cycle-time--missing {
  background: #fff3d6;
  color: #9a6200;
}

.operator-output-qty,
.operator-time-comparison,
.operator-performance {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.operator-output-qty__ok {
  color: #137333;
  font-weight: 700;
}

.operator-output-qty__reject {
  color: #b42318;
  font-size: 11px;
}

.operator-time-comparison span {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  color: #5b6f89;
}

.operator-time-comparison strong {
  color: #193b66;
}

.operator-variance--saved {
  color: #137333;
  font-weight: 700;
}

.operator-variance--over {
  color: #b42318;
  font-weight: 700;
}

.operator-variance--missing {
  color: #697586;
  font-weight: 600;
}

.operator-performance {
  min-width: 116px;
  padding: 6px 10px;
  border-radius: 7px;
}

.operator-performance strong {
  font-size: 14px;
}

.operator-performance span {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.operator-performance--good {
  background: #e5f6eb;
  color: #137333;
}

.operator-performance--steady {
  background: #e8f1ff;
  color: #0759c7;
}

.operator-performance--review {
  background: #fff0ed;
  color: #b42318;
}

.operator-performance--missing {
  background: #f1f3f6;
  color: #697586;
}

@media (max-width: 900px) {
  .operator-efficiency-explainer {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/reports/OperatorsEfficiency.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,cAAA;EACA,eAAA;AACF;;AAEA;;;EAGE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,mBAAA;EACA,cAAA;AACF;;AAEA;;;EAGE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE;IACE,uBAAA;IACA,sBAAA;IACA,QAAA;EACF;AACF","sourcesContent":[".operator-efficiency-formula {\n  margin: 4px 0 0;\n  color: #4b6384;\n  font-size: 12px;\n}\n\n.operator-efficiency-explainer {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-top: 12px;\n  padding: 10px 14px;\n  border: 1px solid #cfe0f5;\n  border-radius: 8px;\n  background: #f5f9ff;\n  color: #183b66;\n  font-size: 12px;\n}\n\n.operator-efficiency-explainer > div {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n}\n\n.operator-efficiency-explainer p {\n  margin: 0;\n  color: #51657f;\n  line-height: 1.45;\n}\n\n.operator-efficiency-explainer__label,\n.operator-muted-text {\n  color: #6b7f99;\n  font-size: 11px;\n}\n\n.operator-coverage,\n.operator-efficiency-value,\n.operator-cycle-time {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 86px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: #e7f6ec;\n  color: #137333;\n  font-weight: 700;\n}\n\n.operator-coverage--warning,\n.operator-cycle-time--missing {\n  background: #fff3d6;\n  color: #9a6200;\n}\n\n.operator-output-qty,\n.operator-time-comparison,\n.operator-performance {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.operator-output-qty__ok {\n  color: #137333;\n  font-weight: 700;\n}\n\n.operator-output-qty__reject {\n  color: #b42318;\n  font-size: 11px;\n}\n\n.operator-time-comparison span {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  color: #5b6f89;\n}\n\n.operator-time-comparison strong {\n  color: #193b66;\n}\n\n.operator-variance--saved {\n  color: #137333;\n  font-weight: 700;\n}\n\n.operator-variance--over {\n  color: #b42318;\n  font-weight: 700;\n}\n\n.operator-variance--missing {\n  color: #697586;\n  font-weight: 600;\n}\n\n.operator-performance {\n  min-width: 116px;\n  padding: 6px 10px;\n  border-radius: 7px;\n}\n\n.operator-performance strong {\n  font-size: 14px;\n}\n\n.operator-performance span {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.operator-performance--good {\n  background: #e5f6eb;\n  color: #137333;\n}\n\n.operator-performance--steady {\n  background: #e8f1ff;\n  color: #0759c7;\n}\n\n.operator-performance--review {\n  background: #fff0ed;\n  color: #b42318;\n}\n\n.operator-performance--missing {\n  background: #f1f3f6;\n  color: #697586;\n}\n\n@media (max-width: 900px) {\n  .operator-efficiency-explainer {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
